import Vue from 'vue';
// import iView from 'view-design';
import { login, logout } from '@/api/user.js';
import { Encrypt, encodeAesString } from '@/utils/crypto.js';
export default {
    namespaced: true,
    state:{
        // 用户昵称
        userName: localStorage.getItem('userName'),
        token: localStorage.getItem('token'),
    },
    mutations:{
        setUser(state,{ loginType,userId,userName,token, tenantAreaCode,areaName, areaType, userInfo = '{}' }){
            // 在这里把用户名和token保存起来
            localStorage.setItem('loginType', loginType);
            localStorage.setItem('userId',userId);
            /* 用户昵称 */
            state.userName = userName;
            localStorage.setItem('userName', userName);
            localStorage.setItem('token', token);
            state.token = token;
            localStorage.setItem('tenantAreaCode', tenantAreaCode);
            localStorage.setItem('areaName', areaName);
            localStorage.setItem('areaType', areaType);
            localStorage.setItem('userInfo', userInfo);
        },
        clearUser(state){
            localStorage.clear();
            sessionStorage.clear();
            Vue.cookie.delete('userId');
            Vue.cookie.delete('userName');
            // Vue.$cookies.keys().forEach(cookie =>{
            //     // console.log(cookie);
            //     Vue.$cookies.remove(cookie);
            // });
            state.token='';
        }
    },
    actions:{
        userLogin(context,{account,password,loginType}){
            return new Promise((resolve, reject) => {
                console.log(process.env.NODE_ENV)
                // if(process.env.NODE_ENV == "development"){
                //     password = Encrypt(password)
                // } else {
                //     account = encodeAesString(account)
                //     password = encodeAesString(password)
                // }
                account = encodeAesString(account)
                password = Encrypt(password)
                login({
                    account: account,
                    password: password,
                    loginType: loginType
                }).then((response)=>{
                    if(response.data.success){
                        let userName=Vue.cookie.get('userName');
                        let userId=Vue.cookie.get('userId');
                        let tenantAreaCode=Vue.cookie.get('tenantAreaCode');
                        let areaName=Vue.cookie.get('areaName') || '';
                        let areaType=Vue.cookie.get('areaType') || '';
                        context.commit('setUser',{
                            loginType:loginType,
                            userId:userId,
                            userName:userName,
                            token:response.data.data,
                            tenantAreaCode:tenantAreaCode,
                            areaName:areaName,
                            areaType:areaType,
                        });
                    }
                    resolve(response);
                }).catch((err)=>{
                    reject(err)
                });
            });
        },
        loginOUt(context,{router}){
            logout().then((res)=>{
                context.commit('clearUser');
                context.commit('resetState',null,{ root: true});
                location.reload();
                // const host ="123.57.205.192:7090";
                // const host =  location.hostname + ":7090"
                // window.open(`http://${host}/slogin`, '_self');
                // router.push({ path: '/index' }) ;
                // location.href='https://xtbg.digitalgd.com.cn/_tif_logout?returnUrl=http://xtbg.digitalgd.com.cn/rz_gdygsm/glm/jg/';
            });
        },
        // 清除缓存退出
        clearCache(context){
            context.commit('clearUser');
            context.commit('resetState',null,{ root: true});
            location.reload();
            // const host =  location.hostname + ":7090"
            // window.open(`http://${host}/slogin`, '_self');
            // location.href='http/s://xtbg.digitalgd.com.cn/_tif_logout?returnUrl=http://xtbg.digitalgd.com.cn/rz_gdygsm/glm/jg/';
        },
    }
}
